import {
  Alert,
  Box,
  Button,
  CircularProgress,
  FormControl,
  FormControlLabel,
  FormHelperText,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  Switch,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  BUTTON_STYLES,
  FORM_STYLES,
  MODAL_STYLES,
  TEXT_FIELD_STYLES,
} from "../../styles/componentStyles";
import { useFormik } from "formik";
import api from "../../axiosInstance";
import { toast } from "react-toastify";
import collegeCourseSchema from "../Validations/BannerValidation";

function CoursesEdit({
  States,
  open,
  onClose,
  collegesCoursesEdit,
  onSuccess,
}) {
  const [categories, setCategories] = useState([]);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [universities, setUniversities] = useState([]);
  console.log(collegesCoursesEdit);

  // Fetch dropdown data once
  useEffect(() => {
    const fetchDropdownData = async () => {
      try {
        const universitiesRes = await api.get(
          "/getCourses/collegeId/universityId",
          {
            params: {
              collegeId: collegesCoursesEdit?.collegeId,
            },
          }
        );
        setUniversities(universitiesRes.data.data);
      } catch (err) {
        const message =
          err.response?.data?.message ||
          err.message ||
          "Something went wrong while fetching dropdown data";
        setError(message);
        console.error("Dropdown fetch error:", err);
      }
    };

    fetchDropdownData();
  }, []);
  // Remove the Dubulicate categories
  const uniqueByCategory = categories.filter(
    (value, index, self) =>
      index === self.findIndex((obj) => obj.category === value.category)
  );

  //  Form vlaidation using useFormik hook
  const formik = useFormik({
    initialValues: {
      collegeId: collegesCoursesEdit?.collegeId || "",
      collegeDisplay: collegesCoursesEdit
        ? `${collegesCoursesEdit.collegeId} - ${collegesCoursesEdit.collegeName}`
        : "" || "",
      courseId: collegesCoursesEdit?.courseId || "",
      active: collegesCoursesEdit?.active ?? "true",
      intakes: collegesCoursesEdit?.intakes || "",
    },

    validationSchema: collegeCourseSchema.collegeCourseSchema,
    enableReinitialize: true,

    onSubmit: async (values, { resetForm, setSubmitting }) => {
      console.log(collegesCoursesEdit?.id);
      try {
        setSubmitting(true);
        let response;
        // If it's Edit data it will call Update api
        if (collegesCoursesEdit?.id) {
          response = await api.put(
            `/api/collegeCourses/${collegesCoursesEdit?.id}`,
            values
          );
          console.log(values);
        }

        // Else it's Add data it will call Add api
        else {
          console.log(values);
        }
        // Show success toast
        toast.success(
          `College Course ${
            collegesCoursesEdit?.id ? "updated" : "added"
          } successfully!`,
          {
            position: "top-right",
            autoClose: 2000,
          }
        );
        onSuccess(response.data.data);
        resetForm();
        onClose();
      } catch (error) {
        toast.error("Failed to submit. Please try again.", {
          autoClose: 3000,
        });
        console.error("API Error:", error);
      } finally {
        setSubmitting(false);
      }
    },
  });
  return (
    <>
      {/* Loading State */}
      {isLoading && (
        <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
          <CircularProgress />
        </Box>
      )}
      <Modal open={open} onClose={onClose} disableScrollLock>
        <Box
          sx={{ ...MODAL_STYLES.standard, width: { xs: 340, md: 500 } }}
          component="form"
          onSubmit={formik.handleSubmit}
        >
          <Typography
            variant="h5"
            component="h2"
            sx={{ mb: 3, fontWeight: 600 }}
          >
            {collegesCoursesEdit && Object.keys(collegesCoursesEdit).length > 0
              ? "Update College"
              : "Add College"}
          </Typography>
          <Box sx={FORM_STYLES.container}>
            <TextField
              label="College Id"
              name="collegeId"
              disabled
              value={formik.values.collegeDisplay}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.collegeId && Boolean(formik.errors.name)}
              helperText={formik.touched.collegeId && formik.errors.collegeId}
              {...TEXT_FIELD_STYLES.standard}
              required
            />
            <FormControl
              fullWidth
              error={formik.touched.courseId && Boolean(formik.errors.courseId)}
            >
              <InputLabel>Course</InputLabel>
              <Select
                name="courseId"
                value={formik.values.courseId}
                onChange={formik.handleChange}
                label="Course"
                onBlur={formik.handleBlur}
                error={
                  formik.touched.courseId && Boolean(formik.errors.courseId)
                }
              >
                {universities.map((u) => (
                  <MenuItem key={u.courseId} value={u.courseId}>
                    {u.courseId} {"-"} {u.courseName}
                  </MenuItem>
                ))}
              </Select>
              {formik.touched.courseId && formik.errors.courseId && (
                <FormHelperText sx={{ color: "red" }}>
                  {formik.errors.courseId}
                </FormHelperText>
              )}
            </FormControl>
            <TextField
              label="intakes"
              name="intakes"
              value={formik.values.intakes}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.intakes && Boolean(formik.errors.intakes)}
              helperText={formik.touched.intakes && formik.errors.intakes}
              {...TEXT_FIELD_STYLES.standard}
            />

            <FormControl
              fullWidth
              error={formik.touched.active && Boolean(formik.errors.active)}
              sx={{ mt: 2 }}
            >
              <InputLabel id="active-label">Active</InputLabel>
              <Select
                labelId="active-label"
                id="active"
                name="active"
                value={formik.values.active}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                label="Active"
              >
                <MenuItem value="true">Yes</MenuItem>
                <MenuItem value="false">No</MenuItem>
              </Select>
              {formik.touched.active && formik.errors.active && (
                <FormHelperText>{formik.errors.active}</FormHelperText>
              )}
            </FormControl>
            <Box
              sx={FORM_STYLES.actions}
              style={{
                display: "flex",
                marginTop: "20px",
                justifyContent: "flex-end",
                gap: "10px",
              }}
            >
              <Button onClick={onClose} {...BUTTON_STYLES.secondary}>
                Cancel
              </Button>
              <Button
                type="submit"
                disabled={formik.isSubmitting}
                {...BUTTON_STYLES.primary}
              >
                {formik.isSubmitting ? "Processing..." : "Save"}
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
    </>
  );
}

export default CoursesEdit;
